(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_mobile-drawer"] && !Shopify.designMode) return;
  try {
    (function() {
    // Close drawer when the close link is tapped, when a nav link is tapped,
    // or when the backdrop is tapped.
    document.addEventListener('click', function (event) {
      var drawer = event.target.closest('.mobile-drawer__root');
      if (!drawer || !drawer.open) return;

      var target = event.target;

      // Close on explicit close control
      if (target.closest('[data-mobile-drawer-close]')) {
        event.preventDefault();
        drawer.open = false;
        return;
      }

      // Close on backdrop tap
      if (target.classList && target.classList.contains('mobile-drawer__backdrop')) {
        drawer.open = false;
        return;
      }

      // Close on leaf link tap (not summary/submenu toggles)
      var leaf = target.closest('a.mobile-drawer__link, a.mobile-drawer__sublink, a.mobile-drawer__cta');
      if (leaf) {
        drawer.open = false;
      }
    });

    // Close drawer on Escape key
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var open = document.querySelector('.mobile-drawer__root[open]');
      if (open) open.open = false;
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
